import PropTypes from "prop-types";
import React from "react";
import { Select } from "cxa-components";
import { injectIntl, intlShape } from "react-intl";

const onPlanChange = (selectedPlanId, plan, onChange) => {
  // trigger plan selection
  const {
    planId,
    planValue,
    price,
    sumAssured,
    uniqueId,
    groupValue,
    intervalOptions = [],
    ...rest
  } = plan;
  const selectedPlan = intervalOptions
    .filter(intervalOpt => intervalOpt.optionId === selectedPlanId)
    .reduce(option => option);
  if (selectedPlan.optionId) {
    onChange({
      ...rest,
      planId: selectedPlan.optionId,
      planValue: selectedPlan.optionId,
      price: selectedPlan.price,
      sumAssured: selectedPlan.sumAssured,
      groupValue: selectedPlan.optionId,
      isSelected: true,
      uniqueId: selectedPlan.uniqueId,
      intervalOptions,
    });
  }
};

const PlanIntervalOptions = ({
  intl,
  plan: { intervalOptions = [], isSelected, planId } = {},
  plan,
  onChange,
  currency,
}) => {
  const intervalOptionCount = (intervalOptions && [].concat(intervalOptions)) || [];
  if (intervalOptionCount <= 1) {
    return null;
  }

  const selectOptions = intervalOptions.map((option, idx) => {
    return (
      <option
        className="benefit-plan__dependant-selection"
        key={idx}
        value={option.optionId}
        disabled={!isSelected}
      >
        {intl.formatNumber(option.planValue, {
          style: "currency",
          currencyDisplay: "code",
          currency: currency,
        })}
      </option>
    );
  });

  return (
    <div
      className="product-plan__options"
      aria-hidden={!intervalOptions || intervalOptions.length === 0}
    >
      <Select
        value={planId}
        onChange={e => onPlanChange(e.target.value, plan, onChange)}
        disabled={!isSelected}
      >
        {selectOptions}
      </Select>
    </div>
  );
};

PlanIntervalOptions.propTypes = {
  plan: PropTypes.object,
  intl: intlShape.isRequired,
};

export default injectIntl(PlanIntervalOptions);



// WEBPACK FOOTER //
// ./components/employee/shop/PlanIntervalOptions.js